import React from 'react';
const facts = [{
  value: '52',
  label: 'Complete sessions, in order',
  tint: 'bg-teal-soft'
}, {
  value: '54',
  label: 'Ten-minute quick directives',
  tint: 'bg-lav-soft'
}, {
  value: '30/40/50',
  label: 'Minute versions of every session',
  tint: 'bg-peach-soft'
}, {
  value: '64',
  label: 'Printable worksheets',
  tint: 'bg-sage-soft'
}];
export function SocialProofBar() {
  return <section className="w-full bg-white" data-id="element-301" data-mp="32iut2xycjjuu">
      <div className="mx-auto max-w-6xl px-5 pb-14 sm:pb-16" data-id="element-302" data-mp="32il2b85h98o3">
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-303" data-mp="2xji9qn6ooux0">
          {facts.map(fact => <div key={fact.label} className={`rounded-2xl px-4 py-5 text-center ${fact.tint}`} data-id="element-304" data-mp="2thwy155vymoe">
              <div className="font-display text-3xl font-semibold leading-none text-navy sm:text-4xl" data-id="element-305" data-mp="2ojv4treqx6z7">
                {fact.value}
              </div>
              <div className="mt-2 text-xs font-semibold text-navy-soft" data-id="element-306" data-mp="1i4ksmpuh9w04">{fact.label}</div>
            </div>)}
        </div>
      </div>
    </section>;
}